import React from 'react';
import { CreditCard, Smartphone, Building } from 'lucide-react';

const PaymentMethods = ({ selectedMethod, onMethodSelect }) => {
  const paymentMethods = [
    {
      id: 'payfast',
      name: 'PayFast',
      description: 'Secure South African payment gateway',
      icon: CreditCard,
      fees: 'Processing fee: 2.9% + R2.90',
      features: ['Instant verification', 'Local bank integration', 'Mobile banking'],
      popular: true
    },
    {
      id: 'paystack',
      name: 'Paystack',
      description: 'Modern payment processing for Africa',
      icon: Smartphone,
      fees: 'Processing fee: 2.9% + R2.00',
      features: ['Card payments', 'Bank transfers', 'Mobile money'],
      popular: false
    },
    {
      id: 'card',
      name: 'Credit/Debit Card',
      description: 'Direct card payment',
      icon: Building,
      fees: 'Processing fee: 3.2%',
      features: ['Visa', 'Mastercard', '3D Secure'],
      popular: false
    }
  ];

  return (
    <div className="mb-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Payment Method</h3>
      <div className="grid grid-cols-1 gap-4">
        {paymentMethods?.map((method) => {
          const IconComponent = method?.icon;
          return (
            <div
              key={method?.id}
              className={`relative p-4 border-2 rounded-lg cursor-pointer transition-all ${
                selectedMethod === method?.id
                  ? 'border-blue-500 bg-blue-50' :'border-gray-200 hover:border-gray-300'
              }`}
              onClick={() => onMethodSelect(method?.id)}
            >
              {method?.popular && (
                <div className="absolute -top-2 left-4 bg-green-500 text-white text-xs px-2 py-1 rounded">
                  Popular
                </div>
              )}
              <div className="flex items-start space-x-3">
                <div className={`p-2 rounded-lg ${
                  selectedMethod === method?.id ? 'bg-blue-100' : 'bg-gray-100'
                }`}>
                  <IconComponent className={`h-5 w-5 ${
                    selectedMethod === method?.id ? 'text-blue-600' : 'text-gray-600'
                  }`} />
                </div>
                
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between">
                    <h4 className="text-sm font-medium text-gray-900">{method?.name}</h4>
                    <div className={`w-4 h-4 border-2 rounded-full ${
                      selectedMethod === method?.id
                        ? 'border-blue-500 bg-blue-500' :'border-gray-300'
                    }`}>
                      {selectedMethod === method?.id && (
                        <div className="w-2 h-2 bg-white rounded-full mx-auto mt-0.5"></div>
                      )}
                    </div>
                  </div>
                  
                  <p className="text-sm text-gray-600 mt-1">{method?.description}</p>
                  <p className="text-xs text-gray-500 mt-1">{method?.fees}</p>
                  
                  <div className="flex flex-wrap gap-1 mt-2">
                    {method?.features?.map((feature, index) => (
                      <span
                        key={index}
                        className="inline-flex items-center px-2 py-1 text-xs bg-gray-100 text-gray-700 rounded"
                      >
                        {feature}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {/* Security Information */}
      <div className="mt-4 p-3 bg-green-50 border border-green-200 rounded-md">
        <div className="flex items-start space-x-2">
          <div className="w-5 h-5 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
          </div>
          <div>
            <p className="text-sm font-medium text-green-900">Secure Payment Processing</p>
            <p className="text-sm text-green-700 mt-1">
              All transactions are encrypted and processed through PCI DSS compliant systems.
              Your payment information is never stored on our servers.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethods;